import { isObject } from "effect/Predicate";

export const objectPredicateMacro = <T>(
  keys: (keyof T | (string & {}))[],
  andCheck: (obj: T) => boolean = () => true,
): ((obj: unknown) => obj is T) => {
  // eslint-disable-next-line @typescript-eslint/no-implied-eval
  return new Function(
    "isObject",
    "andCheck",
    "value",
    `return isObject(value) ${keys.map((key) => `&& ${JSON.stringify(key)} in value`).join(" ")} && andCheck(value);`,
  ).bind(null, isObject, andCheck);
};
